import {
  HomeBanner,
  HomeContainer,
  HomeGenericCategories,
  HomeFilterableCategories,
  HomeFooter,
  HomeReorderRail,
} from './components';

export const Home = {
  Container: HomeContainer,
  Banner: HomeBanner,
  GenericCategories: HomeGenericCategories,
  FilterableCategories: HomeFilterableCategories,
  ReorderRail: HomeReorderRail,
  Footer: HomeFooter,
};
